import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisationName string
 * @return {Promise<any>|Promise}
 */
export default (function (organisationName) {
    var url = applyPathVariables(EndPoints.USER_ADD_ORGANISATION, {});
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        data: { 'organisationName': organisationName }
    });
    return request.execute();
});
